export default {"src":"/_next/static/media/hot-cup.d3dc6dca.svg","height":464,"width":464};